import { BuildConfiguration } from ".";
import { DEV_URL, PROD_URL, PROD_URL_HEADERS_TEST } from "./Constants";
import { GameListType, GameType } from "./GameList";
import { ReturnFrontendParametersString, checkIfMobile } from "./Parameters";
import { findGame } from "./Utils";
import * as Sentry from "@sentry/browser";

type BuildUrls = {
  development?: string;
  online: string;
  onlineSelective: string;
  e2Web: string;
  e2Mobile: string;
};

const buildUrlsDev = {
    development: DEV_URL + "builds/engin3/development/web/latest/",
    online: DEV_URL + "online/",
    onlineSelective: DEV_URL + "onlineSelective/",
    e2Web: "https://gs-client.testowaplatforma123.net/online/development/demo/single_run/game.html",
    e2Mobile: "https://gs-client.testowaplatforma123.net/online/development/demo_mobile/single_run/game.html",
} as const satisfies BuildUrls;

const buildUrlsProd = {
    online: PROD_URL + "online/",
    onlineSelective: PROD_URL + "onlineSelective/",
    e2Web: "https://static-prod.beefee.co.uk/e2-web/single_run/game.html",
    e2Mobile: "https://static-prod.beefee.co.uk/e2-mobile/single_run/game.html",
} as const satisfies BuildUrls;

const buildUrlsProdTestHeaders = {
    online: PROD_URL_HEADERS_TEST + "online/",
    onlineSelective: PROD_URL_HEADERS_TEST + "onlineSelective/",
    e2Web: "https://static-prod.beefee.co.uk/e2-web/single_run/game.html",
    e2Mobile: "https://static-prod.beefee.co.uk/e2-mobile/single_run/game.html",
} as const satisfies BuildUrls;

export function redirectUrl(url: URL, gameList: GameListType, buildConfiguration: BuildConfiguration): string {
    console.log(url, "url")

    //awful hack for old gs, TODO: delete when backend updates gs on frozen envs
    //hack for old gs, check tests
    if (url.searchParams.get("stage")?.split("?").length === 2 && ["staging", "stage1", "stage2", "stage3", "stage4"].includes(url.searchParams.get("stage").split("?")[0])) {
        Sentry.captureMessage("Old gs hack - stage", { level: "info" })
        return url.origin + url.pathname + "?" + url.search.replace("?", "").replace("?", "&");
    }

    //second hack for old gs, check tests, please let me out
    if (url.searchParams.get("hackRulesMaxWinningsCap")?.split("?").length === 2 && url.searchParams.get("hackRulesMaxWinningsCap").split("?")[0] === "true") {
        Sentry.captureMessage("Old gs hack - hackRulesMaxWinningsCap", { level: "info" })
        return url.origin + url.pathname + "?" + url.search.replace("?", "").replace("?", "&");
    }

    //third hack for old gs, check tests, please let me out
    if (url.searchParams.get("showMaxHourlyLossRules")?.split("?").length === 2 && url.searchParams.get("showMaxHourlyLossRules").split("?")[0] === "true") {
        Sentry.captureMessage("Old gs hack - showMaxHourlyLossRules", { level: "info" })
        return url.origin + url.pathname + "?" + url.search.replace("?", "").replace("?", "&");
    }


    //gennerally awful hack for new jackpots, will be deleted later, when we fix jackpots on backend too
    if (url.searchParams.get("gameUrl")) { //https://beefee.slack.com/archives/C05FDRJ2878/p1700041158277549
        return hackRedirectWhenJackpotsEnabled(url)
    }

    let game = findGame(url.searchParams.get("gameId"), gameList);

    const brandedGameVersion = findGame(url.searchParams.get("gameId") + "-" + url.searchParams.get("operatorId"), gameList);
    if (url.searchParams.get("addOperatorIdToGameId") === "true" && brandedGameVersion) {
        url.searchParams.set("gameId", brandedGameVersion.id)
        game = brandedGameVersion
    }

    if (!game) {
        throw new Error("Game not added to gamelist: " + url.searchParams.get("gameId"));
    }


    const stageParam = url.searchParams.get("stage");

    if (!stageParam) {
        throw new Error("Neither stage or buildType has been set")
    }

    let buildOrigin: BuildUrls;
    const stageDevelopment = stageParam === "development";
    if(!stageDevelopment && url.href.includes(PROD_URL)) {
        buildOrigin = buildUrlsProd;
    } else if(!stageDevelopment && url.href.includes(PROD_URL_HEADERS_TEST)) {
        buildOrigin = buildUrlsProdTestHeaders;
    } else {
        buildOrigin = buildUrlsDev;
    }

    let buildType = game[stageParam]
    //overwrite path to development with e2 if this is an e2 game, TODO: DELETE ONCE E2 IS NO LONGER USED
    if (game["staging"] === "e2" && stageParam === "development") {
        buildType = "e2"
    }

    console.log(buildOrigin, buildType)

    const inputParams = url.search;
    console.log("input url params:\n", inputParams);
    let outputParams = ReturnFrontendParametersString(url.searchParams, buildType === "e2" ? "e2" : "e3", gameList);
    outputParams = hackRemoveJackpotsInfoFromOutputParamsForEnergyCasino(outputParams, url);
    console.log("output url params:\n", outputParams);

    let newUrl = "";
    if (buildType === "online" || buildType === "onlineSelective") {
        const buildNumber = buildConfiguration[buildType][stageParam]
        newUrl += buildOrigin[buildType] + buildNumber + "/";
    } else if (buildType === "e2") {
        newUrl += checkIfMobile() ? buildOrigin.e2Mobile : buildOrigin.e2Web;
    } else if (stageParam === "development") {
        newUrl += buildUrlsDev.development
    }
    newUrl += "?" + outputParams;
    console.log("Returning URL: ", newUrl)
    return newUrl;
}

function hackRedirectWhenJackpotsEnabled(url: URL): string {
    console.log(url.searchParams.get("sessionId"), "SESSION ID")
    const rules = url.searchParams.get("jackpotRulesTemplateUrl")
    const rulesUrl = url.searchParams.get("jackpotRulesUrl")
    const extraRulesUrl = url.searchParams.get("jackpotExtraRulesUrl")
    return atob(url.searchParams.get("gameUrl")) + "&jackpotRulesTemplateUrl=" + rules + "&jackpotRulesUrl=" + rulesUrl + "&jackpotExtraRulesUrl=" + extraRulesUrl;
}
//TODO: REMOVE ASAP WHEN PROPERLY FIXED WITH BACKEND
function hackRemoveJackpotsInfoFromOutputParamsForEnergyCasino(outputParams: string, url: URL): string {
    const operatorId = url.searchParams.get("operatorId");
    if (operatorId !== "energycasino") {
        return outputParams
    }
    const gamesWithoutJackpots = [
        "1d4d0dc8-9f7d-11e7-abc4-cec278b6b50a",
        "buffalo-trail",
        "buffalo-trail-dice",
        "buffalo-trail-lite",
        "buffalo-trail-ultra",
        "burning-slots-cash-mesh",
        "burning-slots-cash-mesh-ultra",
        "burning-slots-cash-mesh-ultra-dice",
        "chicken-madness",
        "chicken-madness-dice",
        "chicken-madness-ultra",
        "classic-xtreme",
        "a719ac2c-d970-40d5-9a53-b42c97ddd917",
        "fiery-slots-cash-mesh",
        "fiery-slots-cash-mesh-ultra",
        "fiery-slots-cash-mesh-ultra-dice",
        "b793d8a9-0da9-485d-a35d-c156057f6c61",
        "hot-classic-dice",
        "b5c841ac-435b-4860-966c-f48873e74209",
        "9b1426c1-da1b-4d0c-a6e9-4a704d4c4602",
        "lucky-symbols-dice",
        "lucky-tropics",
        "3db7ec4a-cdfc-4422-b1c7-4b405b096595",
        "500e6195-2b7f-4ac4-94c1-91c8cfc3a6ae",
        "d9c4175e-6d82-49ec-be43-58bde4b56f43",
        "road-2-cash-dice",
        "rome-warrior-dice",
        "royal-win-dice",
        "caf1bcb7-020d-431c-9ab6-97bf9b94f594",
        "079f8995-8fd4-4678-9a67-23610bb17172",
        "stunning-cash",
        "stunning-cash-ultra",
        "stunning-crown-cash-mesh",
        "stunning-crown-cash-mesh-ultra",
        "9e1936a7-cd05-4559-afc6-85639955e903",
        "6e7e12cc-a9f6-4c25-b3e6-a017d0ceba44",
        "stunning-peppermill-dice",
        "a4508224-3475-11e6-ac61-9e71128cae77",
        "542a0952-a7ce-4ccd-abeb-dbc4a3a6abc4",
        "49170ce8-8839-418c-8cb6-9d1ac5360701"
    ]

    const gameId = url.searchParams.get("gameId")
    if (gamesWithoutJackpots.includes(gameId)) {
        Sentry.captureMessage("remove jackpots in energycasino", { level: "info" })
        return outputParams.replaceAll("&jackpot", "&unusedJackpot")
    }
    return outputParams
}